import {
  INTEGRATION_TYPES,
  type IntegrationType,
} from './integrations.constants';

export const INTEGRATION_DISPLAY_NAMES: Partial<
  Record<IntegrationType | 'google_drive' | 'box', string>
> = {
  [INTEGRATION_TYPES.JIRA]: 'Jira',
  [INTEGRATION_TYPES.LINEAR]: 'Linear',
  [INTEGRATION_TYPES.SLACK]: 'Slack',
  [INTEGRATION_TYPES.MICROSOFT_TEAMS]: 'Microsoft Teams',
  [INTEGRATION_TYPES.CONFLUENCE]: 'Confluence',
  [INTEGRATION_TYPES.SERVICENOW]: 'ServiceNow',
  [INTEGRATION_TYPES.GITHUB_ISSUES]: 'GitHub Issues',
  [INTEGRATION_TYPES.PAGERDUTY]: 'PagerDuty',
  [INTEGRATION_TYPES.TORQ]: 'Torq',
  [INTEGRATION_TYPES.NOTION]: 'Notion',
  [INTEGRATION_TYPES.SPLUNK]: 'Splunk',
  [INTEGRATION_TYPES.GLEAN]: 'Glean',
  [INTEGRATION_TYPES.WIZ]: 'Wiz',
  [INTEGRATION_TYPES.UPWIND]: 'Upwind',
  [INTEGRATION_TYPES.NOVA]: 'Nova',
  [INTEGRATION_TYPES.XPANSE]: 'Cortex Xpanse',
  [INTEGRATION_TYPES.CROWDSTRIKE]: 'Falcon Surface',
  [INTEGRATION_TYPES.HACKERONE]: 'HackerOne',
  [INTEGRATION_TYPES.BUGCROWD]: 'Bugcrowd',
  [INTEGRATION_TYPES.JENKINS]: 'Jenkins',
  [INTEGRATION_TYPES.BITBUCKET]: 'Bitbucket',
  [INTEGRATION_TYPES.MISCONFIG_RESEARCHER]: 'Misconfig Researcher',
  google_drive: 'Google Drive',
  box: 'Box',
};

export const getIntegrationDisplayName = (providerKey: string): string =>
  INTEGRATION_DISPLAY_NAMES[providerKey as IntegrationType] ??
  `${providerKey.charAt(0).toUpperCase()}${providerKey.slice(1)}`;

export const resolveIntegrationTypeFromLabel = (
  sourceLabel: string,
): IntegrationType | null => {
  const normalizedSourceLabel = sourceLabel.trim().toLowerCase();

  return (
    Object.values(INTEGRATION_TYPES).find((provider) => {
      const normalizedProvider = provider.toLowerCase();
      const normalizedDisplayName =
        getIntegrationDisplayName(provider).toLowerCase();

      return (
        normalizedSourceLabel === normalizedProvider ||
        normalizedSourceLabel.startsWith(`${normalizedProvider} `) ||
        normalizedSourceLabel === normalizedDisplayName ||
        normalizedSourceLabel.startsWith(`${normalizedDisplayName} `)
      );
    }) ?? null
  );
};
